import axios from "axios";
import ApiException from "./ApiException";
import config from "@/app.config.json";

const urlBase = `${config.urlApi}/Permissoes`;

function getToken() {
  const token = localStorage.getItem("token");
  return token ? `Bearer ${token}` : "";
}

export interface Permissao {
  permissaoId: number;
  chave: string;
  descricao: string;
}

export interface PermissaoUsuario extends Permissao {
  possui: boolean;
}

export interface SalvarPermissoesDTO {
  usuarioId: number;
  permissaoIds: number[];
}

/** Lista todas as permissões do sistema. */
export const obter = (): Promise<Permissao[]> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();
    axios.get(urlBase)
      .then(r => resolve(r.data))
      .catch(e => reject(new ApiException(e || "Falha ao obter permissões")));
  });
};

/** Retorna permissões de um usuário com flag se ele as possui. */
export const obterPermissoesUsuario = (usuarioId: number): Promise<PermissaoUsuario[]> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();
    axios.get(`${urlBase}/PermissoesUsuario/${usuarioId}`)
      .then(r => resolve(r.data))
      .catch(e => reject(new ApiException(e || "Falha ao obter permissões do usuário")));
  });
};

/** Salva (substitui) as permissões de um usuário. */
export const salvarPermissoesUsuario = (dto: SalvarPermissoesDTO): Promise<{ mensagem: string }> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();
    axios.post(`${urlBase}/SalvarPermissoesUsuario`, dto)
      .then(r => resolve(r.data))
      .catch(e => reject(new ApiException(e || "Falha ao salvar permissões")));
  });
};
